import React, { useEffect } from "react";
import { Layout, Card, Typography, Space, Avatar, Button, Form, Input, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";

import AppHeader from "../../components/Header";
import AppFooter from "../../components/Footer";
import "./index.css";

const { Content } = Layout;
const { Title, Text, Paragraph, Link } = Typography;

export default function About({
  aboutInfo,
  onUpdateAboutInfo,
  loading,
  canEdit,
  loggedInUser,
  onLogout,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (aboutInfo) form.setFieldsValue(aboutInfo);
  }, [aboutInfo, form]);

  const handleSave = async () => {
    const values = await form.validateFields();
    onUpdateAboutInfo(values);
  };

  return (
    <Layout className="dmc dmc-layout page-shell about-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />

      <Content className="page-content about-content">
        <div className="about-container">
          <Title level={3} style={{ marginBottom: 8 }}>关于我</Title>
          <Text type="secondary">个人信息展示与编辑</Text>

          {loading ? (
            <div className="state-block"><Spin /></div>
          ) : (
            <div className="about-grid">
              <Card className="about-card">
                <Space direction="vertical" size={14} style={{ width: "100%" }}>
                  <Space align="center" size={14}>
                    <Avatar size={72} src={aboutInfo.avatar} icon={<UserOutlined />} />
                    <div>
                      <Title level={4} style={{ margin: 0 }}>{aboutInfo.name}</Title>
                      <Text type="secondary">{aboutInfo.intro}</Text>
                    </div>
                  </Space>

                  <Paragraph>{aboutInfo.details}</Paragraph>

                  <div className="about-row"><Text type="secondary">邮箱：</Text><Text>{aboutInfo.email}</Text></div>
                  <div className="about-row"><Text type="secondary">技术栈：</Text><Text>{aboutInfo.techStack}</Text></div>
                  <div className="about-row"><Text type="secondary">兴趣：</Text><Text>{aboutInfo.interests}</Text></div>

                  <Space wrap>
                    <Link href={aboutInfo.github} target="_blank">GitHub</Link>
                    <Link href={aboutInfo.linkedin} target="_blank">LinkedIn</Link>
                    <Link href={aboutInfo.personalHomepage} target="_blank">Homepage</Link>
                  </Space>
                </Space>
              </Card>

              <Card
                className="about-card"
                title="编辑资料"
                extra={canEdit ? <Button type="primary" onClick={handleSave}>保存</Button> : null}
              >
                <Form form={form} layout="vertical" disabled={!canEdit}>
                  <Form.Item label="昵称" name="name" rules={[{ required: true, message: "请输入昵称" }]}><Input /></Form.Item>
                  <Form.Item label="头像链接" name="avatar"><Input /></Form.Item>
                  <Form.Item label="一句话介绍" name="intro"><Input /></Form.Item>
                  <Form.Item label="详细介绍" name="details"><Input.TextArea rows={4} /></Form.Item>
                  <Form.Item label="邮箱" name="email"><Input /></Form.Item>
                  <Form.Item label="技术栈" name="techStack"><Input /></Form.Item>
                  <Form.Item label="兴趣" name="interests"><Input /></Form.Item>
                  <Form.Item label="GitHub" name="github"><Input /></Form.Item>

                  {!canEdit && <Text type="secondary" style={{ fontSize: 12 }}>登录后才可编辑</Text>}
                </Form>
              </Card>
            </div>
          )}
        </div>
      </Content>

      <AppFooter />
    </Layout>
  );
}
